// extracted by mini-css-extract-plugin
export default {"tagsContainer":"a5Kj4t","alignCenter":"b5Kj4t","external":"c5Kj4t","tag":"d5Kj4t","scroll":"e5Kj4t","column":"f5Kj4t"};